<template>

  <div>
    <sample-header>
    </sample-header>
    <div class="content homepage">
      <!--<div class="homepage__gradient">-->
        <div class="homepage__hero">
          <div class="center-content">
            <div class="row">
              <div class="columns small-12">
                <loading-indicator message="Loading" v-if="pageLoading"></loading-indicator>
                <v-content v-else>
                  <v-container fluid>
                  <v-layout class="login-layout">
                    <v-flex xs8 sm6 md4>
                    <v-card class="login">
                      <form @submit.prevent="login" autocomplete="off">
                      <div class="text-xs-center" style="padding:30px 15px;">
                          <img src="../assets/images/Essilor_RGB_Blue.jpg" height="75%" width="75%">
                      </div>
                      <div class="text-xs-center">
                          <h5>Login to your account</h5>
                      </div>
                      <!-- <div class="text-xs-center" style="padding-top:20px;" v-if="errorName">
                          <p style="color: red; margin: 0; text-transform: capitalize">{{ errorName||'' }}</p>
                          <p>
                            <small style="color: red">{{ errorDescription }}</small>
                          </p>
                      </div> -->
                      <v-card-text>
                          <div class="text-xs-center" style="padding: 5px 40px">
                          <v-btn
                              :loading="loading"
                              color="#0000ff"
                              style="width:100%; margin: 0"
                              class="white--text"
                              type="submit"
                          >Login</v-btn>
                          </div>
                      </v-card-text>
                      </form>
                    </v-card>
                    </v-flex>
                  </v-layout>
                  </v-container>
                </v-content>
              </div>
            </div>
          </div>
        </div>
      <!--</div>-->
    </div>
    <sample-footer>
    </sample-footer>
  </div>
  
</template>
<script>
import auth from "@/api/auth.js";
import { msalInstance } from "vue-msal-browser";
import SampleHeader from "@/components/layout/SampleHeader";
import SampleFooter from "@/components/layout/SampleFooter";
import LoadingIndicator from "@/components/layout/LoadingIndicator";

export default {
  components: { SampleHeader, SampleFooter,LoadingIndicator },
  data() {
    return {
      email: "",
      pass: "",
      error: false,
      loading: false,
      pageLoading:true
      //resetUrl: process.env.VUE_APP_OKTA_SERVER + "/signin/forgot-password"
    };
  },
  computed: {
    errorName() {
      return this.$route.query.errorName
    },
    errorDescription() {
      return this.$route.query.errorDescription
    },
  },
  beforeRouteEnter(to, from, next) {
    localStorage.setItem("accessingUrl", to.query.redirect != null ? to.query.redirect : '/');
    next()
  },
  methods: {
    login() {
      // localStorage.setItem("referrerPath", "/");
      // localStorage.removeItem('vuex');
      // localStorage.removeItem('programKey')
      this.loading = true;
      // auth.login(this.email, this.pass, loggedIn => {
      //   if (!loggedIn) {
      //     this.error = true;
      //     this.loading = false;
      //   }  else {
      //     this.$store.dispatch("login");
      //     this.$router.replace(this.$route.query.redirect || "/");
      //     this.loading = false;
      //   }
      // });
      try{
        auth.login();
      }catch(err){
        auth.logout()
      }
    },
    logout() {
      auth.logout();
      localStorage.removeItem('vuex');
      localStorage.removeItem('programKey')
      this.$store.dispatch("logout");
    }
  },
  computed:{
  },async mounted(){
    msalInstance.handleRedirectPromise().then(res=>{
      const acc = msalInstance.getAllAccounts();
      if(acc.length > 0){
        msalInstance.setActiveAccount(acc[0]);
        this.$router.replace({path:auth.getFromUri()})
        this.pageLoading = false;
      }else{
        sessionStorage.removeItem('msal.interaction.status');
        this.pageLoading = false;
      }
    });
  }
};
</script>

<style scoped>
.error {
  color: red;
}

.login {
  margin-top: 20px;
  border-radius: 25px;
}

.login-layout {
  display: flex;
  justify-content: center;
}

@media screen and (max-width: 768) {
  .login-layout {
    margin-top: 10%;
  }
}
</style>
